// ============================================================================
// Calendar Color Palette
// ============================================================================

export interface CalendarPresetColor {
  name: string;
  hex: string;
}

/**
 * Preset color palette for calendar connections and sub-calendars.
 * Colors must be globally unique per user across all connections and calendars.
 */
export const CALENDAR_PRESET_COLORS: CalendarPresetColor[] = [
  { name: 'Tomato', hex: '#d50000' },
  { name: 'Flamingo', hex: '#e67c73' },
  { name: 'Tangerine', hex: '#f4511e' },
  { name: 'Banana', hex: '#f6bf26' },
  { name: 'Sage', hex: '#33b679' },
  { name: 'Basil', hex: '#0b8043' },
  { name: 'Peacock', hex: '#039be5' },
  { name: 'Blueberry', hex: '#3f51b5' },
  { name: 'Lavender', hex: '#7986cb' },
  { name: 'Grape', hex: '#8e24aa' },
  { name: 'Graphite', hex: '#616161' },
  { name: 'Slate', hex: '#455a64' },
  { name: 'Cocoa', hex: '#795548' },
  { name: 'Pumpkin', hex: '#ef6c00' },
  { name: 'Avocado', hex: '#c0ca33' },
  { name: 'Eucalyptus', hex: '#009688' },
];
